import React from 'react';
import ReactDOM from 'react-dom';
import Landing from './Landing';
ReactDOM.render(

    <Landing />,

  document.querySelector('#root'),
);
